import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NavigateService } from './service/navigate.service';
import { UserService } from './service/user.service';
import { HttpClientService } from './service/http-client.service';
import { AppConfigService } from './service/app-config.service';

import { AboutIndexComponent } from './about/about-index/about-index.component';
import { AboutIndexDetailComponent } from './about/about-index-detail/about-index-detail.component';
import { AdvisorComponent } from './about/advisor/advisor.component';
import { CommitteeComponent } from './about/committee/committee.component';
import { ContactUsComponent } from './about/contact-us/contact-us.component';
import { EventsIndexComponent } from './events/events-index/events-index.component';
import { DetailComponent } from './events/detail/detail.component';
import { DetailWorkshopComponent } from './events/detail-workshop/detail-workshop.component';
import { ProDevIndexComponent } from './professional-dev/pro-dev-index/pro-dev-index.component';
import { ProDetailComponent } from './professional-dev/pro-detail/pro-detail.component';
import { SchoolComponent } from './knowledgecenter/school/school.component';
import { SchooldetailComponent } from './knowledgecenter/schooldetail/schooldetail.component'
import { NewsIndexComponent } from './news/news-index/news-index.component';
import { MembershipComponent } from './membership/membership/membership.component';
import { OurPartnersComponent } from './membership/ourPartners/ourPartners.component'
import { RegisterComponent } from './register/register/register.component';
import { PersonComponent } from './person/person.component';
import { PagenotfoundComponent } from './share/pagenotfound/pagenotfound.component';
import { EventsWorkshopComponent } from './events/events-workshop/events-workshop.component';
import { EventsCywvfComponent } from './events/events-cywvf/events-cywvf.component';
import { JobComponent } from './professional-dev/job/job.component';
import { SeniorSchoolComponent } from './knowledgecenter/senior-school/senior-school.component';
import { TransferComponent } from './knowledgecenter/transfer/transfer.component';
import { RankingComponent } from './knowledgecenter/ranking/ranking.component';
import { PublicationComponent } from './news/publication/publication.component';
import { ResearchComponent } from './news/research/research.component';
import { SeniorSchooldetailComponent } from './knowledgecenter/senior-schooldetail/senior-schooldetail.component';
import { ResetPwdComponent } from './person/reset-pwd/reset-pwd.component';
import { VerifyEmailComponent } from './person/verify-email/verify-email.component';
import { RegisterNocodeComponent } from './register/register-nocode/register-nocode.component';
import { LoginComponent } from './login/login.component';
import { SearchComponent } from './knowledgecenter/search/search.component';
import { NewsDetailComponent } from './news/news-detail/news-detail.component';
import { NewsVirusComponent } from './news/news-virus/news-virus.component';
import { NewsVirusDetailComponent } from './news/news-virus-detail/news-virus-detail.component';
import { WebinarComponent } from './professional-dev/webinar/webinar.component';
import { WebinarDetailComponent } from './professional-dev/webinar-detail/webinar-detail.component';
import { QuestionsComponent } from './professional-dev/questions/questions.component';
import { UniversityComponent } from './knowledgecenter/university/university.component';
import { PersonalDataComponent } from './person/personal-data/personal-data.component';
import { ModifyPasswordComponent } from './person/modify-password/modify-password.component';
import { MyQAndAComponent } from './person/my-q-and-a/my-q-and-a.component';
import { MyCommentsComponent } from './person/my-comments/my-comments.component';
import { MessageCenterComponent } from './person/message-center/message-center.component';
import { MembershipCommittee } from './about/membership-committee/membership.component';

import { VoteComponent } from './vote/index/vote.component'
import { VoteDetailComponent } from './vote/vote-detail/vote-detail.component'


const appRouters: Routes = [
	{ path: '', redirectTo: '/home', pathMatch: 'full' },
	{ path: 'about', component: AboutIndexComponent },

	{ path: 'aboutChinaIcac/membershipCommittee', component: MembershipCommittee },

	{ path: 'aboutChinaIcac/Overview', component: AboutIndexComponent },
	{ path: 'aboutChinaIcac/ExecutiveBoard', component: AboutIndexComponent },
	{ path: 'aboutChinaIcac/OrganizationalStructure', component: AboutIndexComponent },
	{ path: 'aboutChinaIcac/Committees', component: AboutIndexComponent },
	{ path: 'aboutChinaIcac/Subcommittees', component: AboutIndexComponent },
	{ path: 'aboutChinaIcac/VolunteerForChinaICAC', component: AboutIndexComponent },
	{ path: 'aboutChinaIcac/ContactUs', component: AboutIndexComponent },
	{ path: 'aboutChinaIcac/detail', component: AboutIndexDetailComponent },
	
	{ path: 'events', component: EventsIndexComponent },

	{ path: 'events/national-Conference', component: EventsIndexComponent },
	{ path: 'events/regional-workshop', component: EventsWorkshopComponent },
	{ path: 'events/cywvf', component: EventsCywvfComponent },
	{ path: 'events/national-Conference/detail/:id', component: DetailComponent },
	{ path: 'events/regional-workshop/questions', component: DetailWorkshopComponent },

	{ path: 'professional', component: WebinarComponent },

	{ path: 'development/webinar', component: WebinarComponent },
	{ path: 'development/webinar/detail/:id', component: WebinarDetailComponent },
	{ path: 'development/pro-job', component: JobComponent },
	{ path: 'development/detail/:id', component: ProDetailComponent },
	{ path: 'development/questions', component: QuestionsComponent },

	{ path: 'knowledgecenter', component: UniversityComponent },

	{ path: 'knowledge-center/university', component: UniversityComponent },
	{ path: 'knowledge-center/university/detail/:id', component: WebinarDetailComponent },
	{ path: 'knowledge-center/high-school', component: SeniorSchoolComponent },
	{ path: 'knowledge-center/ranking', component: RankingComponent },
	{ path: 'knowledge-center/transfer', component: TransferComponent },
	{ path: 'knowledge-center/detail/:id', component: SchooldetailComponent },
	{ path: 'knowledge-center/highschool-detail/:id', component: SeniorSchooldetailComponent },
	{ path: 'knowledge-center/university/search/:query', component: SearchComponent },
	{ path: 'knowledge-center/high-school/search/:query', component: SearchComponent },

	{ path: 'news', component: NewsIndexComponent },

	{ path: 'news/newsroom', component: NewsIndexComponent },
	{ path: 'news/publication', component: PublicationComponent },
	{ path: 'news/research', component: ResearchComponent },
	{ path: 'news/news-detail/:id', component: NewsDetailComponent },
	{ path: 'news/news-COVID-19', component: NewsVirusComponent },
	{ path: 'news/news-COVID-19-detail/:id', component: NewsVirusDetailComponent },

	{ path: 'membership', component: MembershipComponent },
	{ path: 'ourpartners', component: OurPartnersComponent },
	{ path: 'register', component: RegisterComponent },
	{ path: 'register-nocode', component: RegisterNocodeComponent },
	{
		path: 'person', component: PersonComponent, children: [
			{ path: 'person-info', component: PersonalDataComponent },
			{ path: 'modify-pwd', component: ModifyPasswordComponent },
			{ path: 'my-q-and-a', component: MyQAndAComponent },
			{ path: 'my-comments', component: MyCommentsComponent },
			{ path: 'message-center', component: MessageCenterComponent },
			{ path: '', redirectTo: 'person-info', pathMatch: 'full' },
		]
	},
	{ path: 'person/verify-email', component: VerifyEmailComponent },
	{ path: 'person/reset-pwd/:username', component: ResetPwdComponent },
	{
		path:'candidate/vote', component: VoteComponent,

	},
	{
		path:'candidate/vote/vote-detail', component: VoteDetailComponent,
	},
	{ path: 'login', component: LoginComponent },

	{ path: '**', component: PagenotfoundComponent },
];

@NgModule({
	imports: [RouterModule.forRoot(appRouters)],
	exports: [RouterModule],
	providers: [NavigateService, UserService, HttpClientService, AppConfigService],
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/app-routing.module.ts